{
  "name": "@graphorin/store-sqlite",
  "version": "0.15.1",
  "description": "Default SQLite-backed persistence layer for the Graphorin framework. Implements every storage contract from `@graphorin/core` (MemoryStore, CheckpointStore, SessionStore, TriggerStore, AuthTokenStore, OAuthServerStore, IdempotencyStore) on top of `better-sqlite3` with WAL hardening, an atomic migration runner, multi-table per-embedder vec0 vector layout, multilingual FTS5, an idle WAL-checkpoint manager, and a passphrase-resolution / encryption-or-fail-fast hook for the optional `@graphorin/store-sqlite-encrypted` cipher subpackage.",
  "license": "MIT",
  "author": "Oleksiy Stepurenko",
  "homepage": "https://github.com/o-stepper/graphorin/tree/main/packages/store-sqlite",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/o-stepper/graphorin.git",
    "directory": "packages/store-sqlite"
  },
  "bugs": {
    "url": "https://github.com/o-stepper/graphorin/issues"
  },
  "keywords": [
    "graphorin",
    "ai",
    "agents",
    "framework",
    "sqlite",
    "better-sqlite3",
    "sqlite-vec",
    "fts5",
    "wal",
    "memory-store",
    "checkpoint-store",
    "session-store",
    "trigger-store",
    "migrations",
    "embeddings",
    "vector-search"
  ],
  "type": "module",
  "sideEffects": false,
  "engines": {
    "node": ">=22.12.0"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./connection": {
      "types": "./dist/connection.d.ts",
      "default": "./dist/connection.js"
    },
    "./migrations": {
      "types": "./dist/migrations/index.d.ts",
      "default": "./dist/migrations/index.js"
    },
    "./encryption": {
      "types": "./dist/encryption/index.d.ts",
      "default": "./dist/encryption/index.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist",
    "src",
    "README.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsdown && node ./scripts/copy-migrations.mjs",
    "typecheck": "tsc --noEmit && tsc -p tsconfig.tests.json",
    "test": "vitest run",
    "lint": "biome check .",
    "clean": "rimraf dist .turbo *.tsbuildinfo"
  },
  "dependencies": {
    "@graphorin/core": "workspace:*",
    "@graphorin/observability": "workspace:*"
  },
  "peerDependencies": {
    "better-sqlite3": "^12.9.0 || ^13.0.0",
    "better-sqlite3-multiple-ciphers": "^12.9.0",
    "sqlite-vec": "~0.1.9",
    "zod": "^3.23.0 || ^4.0.0"
  },
  "peerDependenciesMeta": {
    "better-sqlite3": {
      "optional": false
    },
    "better-sqlite3-multiple-ciphers": {
      "optional": true
    },
    "sqlite-vec": {
      "optional": false
    },
    "zod": {
      "optional": true
    }
  },
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "devDependencies": {
    "@types/better-sqlite3": "^7.6.13",
    "better-sqlite3": "^12.9.0",
    "sqlite-vec": "~0.1.9"
  }
}
